const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/tests.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/therapist/tests")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});